import { useEffect } from 'react';
import { UseLazyQuery } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import {
  FetchArgs,
  BaseQueryFn,
  QueryDefinition,
  FetchBaseQueryMeta,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/dist/query';

import useUserInfo from '@/hooks/useUserInfo';
import useUserCommand from '@/hooks/useUserCommand';

import { ValueOf } from '@/types';
import { servicesTags } from '@/services';

type TestQuery = {
  userId?: string;
  commandId?: string;

  // TODO:
  // Очень тупое временное решение
  // которое закрывает 90% кейсов в целом
  limit?: number | string;
};

type Test<T> = UseLazyQuery<
  QueryDefinition<
    TestQuery | void,
    BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, any, FetchBaseQueryMeta>,
    ValueOf<typeof servicesTags>,
    T
  >
>;

const useUserData = <T>(hook: Test<T>, id?: string) => {
  const { userInfo, isMaster } = useUserInfo();
  const [getData, { data }] = hook();

  const { commandId: userCommandId } = useUserCommand();

  const userId = isMaster ? userInfo?.id : id;
  const commandId = isMaster ? userInfo?.command.id : userCommandId;

  useEffect(() => {
    if (!userId) return;
    getData({ userId, commandId, limit: 100 });
  }, [commandId, getData, userId]);

  return data;
};

export default useUserData;
